import Joi from 'joi'

export const analyzerSchema = Joi.object({
  type: Joi.string().valid('Manual', 'Ingress').required(),
  name: Joi.string().max(30).required(),
  description: Joi.string().allow('').optional(),
  scriptId: Joi.string().required(),
  configId: Joi.string().required(),
  datasetId: Joi.string().required(),
  scriptExecUser: Joi.string().allow(null, '').optional()
})
